export default __webpack_public_path__ + "static/media/doctor-home.ae797855.svg";